import { createContext, useState } from "react";

export const PageContext = createContext({
  page: "",
});

function PageContextProvider({ children }) {
  const [page, setPage] = useState("home");

  const value = { page, setPage };

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}

export default PageContextProvider;
